import React from 'react';
import PropTypes from 'prop-types';
import RadioIconSelected from '@/assets/radioIconSelected.svg';
import RadioIconNotSelected from '@/assets/radioniconNotselected.svg';
import './RadioButton.css';

const RadioButton = ({
  name,
  value,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  children,
  useCustomIcons = false,
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <label className={`radio-button ${disabled ? 'radio-button--disabled' : ''} ${useCustomIcons ? 'radio-button--custom-icons' : ''} ${className}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="radio-button__input"
        {...props}
      />
      {useCustomIcons ? (
        <img 
          src={checked ? RadioIconSelected : RadioIconNotSelected} 
          alt="" 
          className="radio-button__custom-icon"
        />
      ) : (
        <span className="radio-button__checkmark"></span>
      )}
      {children && <span className="radio-button__label">{children}</span>}
    </label>
  );
};

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  useCustomIcons: PropTypes.bool,
};

export default RadioButton;